/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC, useState, useEffect } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import { API } from '../../../app/services/API'
import { sendMesssageToLivechat } from './../../../app/modules/apps/chat/service/ChatService';
import {
  toAbsoluteUrl,
  defaultMessages,
  defaultUserInfos,
  MessageModel,
  UserInfoModel,
  messageFromClient,
} from '../../helpers'
import { Modal, Button, ListGroup, Form } from 'react-bootstrap-v5';
import { RichMessage } from './RichMessage';

type Props = {
  isDrawer?: boolean,
  chat?: any,
  isBot?: any,
  messages?: any[],
  onSend?: any,
  sessionId?: any,
  hasPermissionChat?: any
}

const email_regex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
const API_URL = process.env.REACT_APP_API_URL
const INTENTS_URL = `${API_URL}/admin/intents`

const bufferMessages = defaultMessages

const ChatTime = ({ time }: any) => {
  const [timeFormat, setTimeFormat] = useState("")
  useEffect(() => {
    setTimeFormat(moment(time).format("DD MMM YYYY HH:mm"))
  }, [time])

  return <span className='text-muted fs-7 mb-1'>{timeFormat}</span>
}

const IntentDetail = ({ message }: any) => {

  const [show, setShow] = useState(false);
  const [intents, setIntents] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    getIntents()
    setShow(true)
  };

  async function getIntents() {
    let result = await API().get(INTENTS_URL)
    setIntents(result.data)
  }

  useEffect(() => {

  }, [])


  return <>

    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>เลือก Intent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup>
          <ListGroup.Item action className="d-flex justify-content-between mb-3">
            Intent #1
            <Button variant="danger" className="d-flex justify-content-center align-items-center" style={{
              padding: 0,
              width: "25px",
              height: "25px",
              borderRadius: "12px"
            }}><i className="bi bi-trash-fill m-0 p-0"></i></Button>
          </ListGroup.Item>
        </ListGroup>

        <Form.Group className="mb-3" controlId="search">
          <Form.Control type="text" placeholder="ค้นหา..." />
        </Form.Group>

        <div style={{
          maxHeight: "300px",
          overflow: "scroll"
        }}>
          <ListGroup>
            <ListGroup.Item action>
              Intent #1
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #2
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #3
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #4
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #5
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #6
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #1
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #2
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #3
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #4
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #5
            </ListGroup.Item>
            <ListGroup.Item action>
              Intent #6
            </ListGroup.Item>
          </ListGroup>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          ปิด
        </Button>
        <Button variant="primary" onClick={handleClose}>
          ยืนยัน
        </Button>
      </Modal.Footer>
    </Modal>

    <div className={clsx(
      'p-1',
      'mt-2',
    )}>
      {/* INTENT <a href="#" onClick={handleShow}>คลิกเพื่อกำหนด Intent</a> */}
    </div></>
}

const ChatInner: FC<Props> = ({ isDrawer = false, sessionId, isBot, chat, onSend, messages = [], hasPermissionChat }) => {
  const contentRef = React.createRef<any>();
  const [chatUpdateFlag, toggleChatUpdateFlat] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  //const [messages, setMessages] = useState<MessageModel[]>(bufferMessages)
  const [userInfos] = useState<UserInfoModel[]>(defaultUserInfos)

  useEffect(() => {
    toggleChatUpdateFlat(!chatUpdateFlag)
    setMessage('')
  }, [sessionId])

  useEffect(() => {
    scrollToBottom()
  }, [messages])

  const scrollToBottom = () => {
    if (contentRef.current)
      contentRef.current.scrollTo(0, contentRef.current.scrollHeight);
  };

  const sendMessage = async () => {
    if (message != "") {

      toggleChatUpdateFlat(!chatUpdateFlag)
      setMessage('')

      await sendMesssageToLivechat(chat.session_id, {
        "type": "text",
        "text": message
      })
    }

    onSend()

    /*const newMessage: MessageModel = {
      user: 2,
      type: 'out',
      text: message,
      time: 'Just now',
    }

    bufferMessages.push(newMessage)
    setMessages(bufferMessages)
    toggleChatUpdateFlat(!chatUpdateFlag)
    setMessage('')
    setTimeout(() => {
      bufferMessages.push(messageFromClient)
      setMessages(() => bufferMessages)
      toggleChatUpdateFlat((flag) => !flag)
    }, 1000)*/
  }

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault()
      sendMessage()
    }
  }

  return (
    <div
      className='card-body'
      id={isDrawer ? 'kt_drawer_chat_messenger_body' : 'kt_chat_messenger_body'}
    >
      <div
        ref={contentRef}
        className={clsx('scroll-y me-n5 pe-5', { 'h-300px h-lg-auto': !isDrawer })}
        data-kt-element='messages'
        data-kt-scroll='true'
        data-kt-scroll-activate='{default: false, lg: true}'
        data-kt-scroll-max-height='auto'
        data-kt-scroll-dependencies={
          isDrawer
            ? '#kt_drawer_chat_messenger_header, #kt_drawer_chat_messenger_footer'
            : '#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer'
        }
        data-kt-scroll-wrappers={
          isDrawer ? '#kt_drawer_chat_messenger_body' : '#kt_content, #kt_chat_messenger_body'
        }
        data-kt-scroll-offset={isDrawer ? '0px' : '-2px'}
      >
        {messages.map((message, index) => {
          const userInfo = userInfos[message.user]
          let text = ""
          message.receive_type = message.agent_id ? 'out' : "in"
          const state = message.receive_type === 'in' ? 'info' : 'primary'
          const templateAttr = {}
          if (message.type == "text") {
            text = message.text.replace(/\n/g, "<br>")
              .replace(/\\n/g, "<br>")
              .replace(
                /(https?:\/\/)([^ ]+)/g,
                '<a target="_blank" href="$&">$2</a>'
              )
              .replace(/((\d[\d\-.]*){9,})/g, '<a href="tel:$1">$1</a>')
              .replace(email_regex, '<a href="mailto:$1">$1</a>')
          } else
            if (message.type == "attachment") {
              if (typeof message.text == "string") {
                let textObject = JSON.parse(message.text)
                if (textObject.type == "image") {
                  text = `<img src="${textObject.payload.url}"/>`
                }else
                if (textObject.type == "vdo") {
                  text = `<a href="${textObject.payload.href}" target="_blank"><img src="${textObject.payload.thumbnail}"/></a>`
                }
              }
            } else if (message.type == "postback") {
              if (typeof message.text == "object") {
                text = message.text.text;
              }
            }
            else if (message.type == "rich") {

            } else
              if (message.type == "quick_replies") {
                let textObject = JSON.parse(message.text)
                text = textObject.title
              } else {
                text = message.text + ""
              }
          if (message.template) {
            Object.defineProperty(templateAttr, 'data-kt-element', {
              value: `template-${message.receive_type}`,
            })
          }
          const contentClass = `${isDrawer ? '' : 'd-flex'} justify-content-${message.receive_type === 'in' ? 'start' : 'end'
            } mb-10`
          return (
            <div
              key={`message${index}`}
              className={clsx('d-flex', 'align-items-center', contentClass, 'mb-10', { 'd-none': message.template })}
              {...templateAttr}
            >
              <div
                className={clsx(
                  'd-flex flex-column align-items',
                  `align-items-${message.receive_type === 'in' ? 'start' : 'end'}`,
                  (message.action == "input.unknown" && message.receive_type === 'in' ? 'chat-message-fallback' : '')
                )}
              >
                <div className='d-flex align-items-center mb-2'>
                  {message.receive_type === 'in' ? (
                    <>
                      <div className='symbol  symbol-35px symbol-circle '>
                        {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}
                      </div>
                      <div className=''>
                        <a
                          href='#'
                          className='fs-5 fw-bolder text-gray-900 text-hover-primary me-1'
                        >
                          {/* {userInfo.name} */}
                          {chat.name}
                        </a>
                        <ChatTime time={message.created_at} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className=''>
                        <ChatTime time={message.created_at} />
                        <a
                          href='#'
                          className='fs-5 fw-bolder text-gray-900 text-hover-primary ms-1'
                        >
                          Agent
                        </a>
                      </div>
                      <div className='symbol  symbol-35px symbol-circle '>
                        {/* <img alt='Pic' src={toAbsoluteUrl(`/media/${userInfo.avatar}`)} /> */}
                      </div>
                    </>
                  )}
                </div>

                {typeof text == "string" && <div
                  className={clsx(
                    'p-5 rounded',
                    `bg-light-${state}`,
                    'text-dark fw-bold mw-lg-400px',
                    `text-${message.receive_type === 'in' ? 'start' : 'start'}`
                  )}
                  data-kt-element='message-text'
                  dangerouslySetInnerHTML={{
                    __html: text
                  }}
                ></div>}
                {message.type == "rich" && <div
                  className={clsx(
                    'p-5 rounded',
                    `bg-light-${state}`,
                    'text-dark fw-bold mw-lg-400px',
                    `text-${message.receive_type === 'in' ? 'start' : 'end'}`
                  )}
                  data-kt-element='message-text'
                ><RichMessage data={message.text} /></div>}

                {(message.receive_type == 'in') && <IntentDetail message={message} />
                }

              </div>
              {(message.action == "input.unknown" && message.receive_type == 'in') && <i className="bi bi-exclamation-circle" style={{
                color: "#F00",
                fontSize: "30px",
                marginLeft: "10px",
              }}></i>}
            </div>
          )
        })}
      </div>

      <div
        className='card-footer pt-4'
        id={isDrawer ? 'kt_drawer_chat_messenger_footer' : 'kt_chat_messenger_footer'}
      >


        {!isBot && hasPermissionChat && <>
          <textarea
            className='form-control form-control-flush mb-3'
            rows={1}
            data-kt-element='input'
            placeholder='Type a message'
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={onEnterPress}
          ></textarea>
          <div className='d-flex flex-stack'>
            <div className='d-flex align-items-center me-2'>
              {/* <button
              className='btn btn-sm btn-icon btn-active-light-primary me-1'
              type='button'
              data-bs-toggle='tooltip'
              title='Coming soon'
            >
              <i className='bi bi-paperclip fs-3'></i>
            </button>
            <button
              className='btn btn-sm btn-icon btn-active-light-primary me-1'
              type='button'
              data-bs-toggle='tooltip'
              title='Coming soon'
            >
              <i className='bi bi-upload fs-3'></i>
            </button> */}
            </div>
            <button
              className='btn btn-primary'
              type='button'
              data-kt-element='send'
              onClick={sendMessage}
            >
              Send
            </button>
          </div></>}
      </div>
    </div>
  )
}

export { ChatInner }
